import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { damga } from "../lib/stamp";
import { SiparisDetay } from "./SiparisDetay";
import { Layers, FileDown, Printer, ArrowDownWideNarrow, ArrowDownAZ, ChevronRight, ChevronDown } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString("tr-TR");
const esc = (v) => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export default function SiparisIsBolumuRaporu() {
  const [data, setData] = useState(null);
  const [sortBy, setSortBy] = useState("adet"); // "adet" | "isim"
  const [open, setOpen] = useState({});
  const toggle = (k) => setOpen((p) => ({ ...p, [k]: !p[k] }));

  useEffect(() => {
    api.get("/dashboard/siparis-is-bolumu").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const sortRows = (arr) => {
    const a = [...(arr || [])];
    if (sortBy === "isim") a.sort((x, y) => x.is_bolumu.localeCompare(y.is_bolumu, "tr"));
    else a.sort((x, y) => y.toplam - x.toplam);
    return a;
  };

  if (!data) return null;
  const rows = data.rows || [];
  const genel = data.genel || {};

  const exportExcel = () => {
    let b = `<tr style="background:#18181B;color:#fff;font-weight:bold;"><th>İş Bölümü</th><th>Horeca</th><th>Horeca KG</th><th>Fason</th><th>Fason KG</th><th>Toplam</th><th>Toplam KG</th></tr>`;
    sortRows(rows).forEach((g) => {
      b += `<tr><td>${esc(g.is_bolumu)}</td><td style="text-align:right;">${g.horeca}</td><td style="text-align:right;">${g.horeca_kg}</td><td style="text-align:right;">${g.fason}</td><td style="text-align:right;">${g.fason_kg}</td><td style="text-align:right;">${g.toplam}</td><td style="text-align:right;">${g.toplam_kg}</td></tr>`;
    });
    b += `<tr style="background:#DBEAFE;font-weight:bold;"><td>GENEL TOPLAM</td><td style="text-align:right;">${genel.horeca}</td><td style="text-align:right;">${genel.horeca_kg}</td><td style="text-align:right;">${genel.fason}</td><td style="text-align:right;">${genel.fason_kg}</td><td style="text-align:right;">${genel.toplam}</td><td style="text-align:right;">${genel.toplam_kg}</td></tr>`;
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table border="1">${b}</table></body></html>`;
    const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `Siparişler İş Bölümü Özeti - ${damga()}.xls`; a.click();
    URL.revokeObjectURL(url);
  };

  const exportPdf = () => {
    const w = window.open("", "_blank"); if (!w) return;
    let b = "";
    sortRows(rows).forEach((g) => {
      b += `<tr><td>${esc(g.is_bolumu)}</td><td class="r">${fmt(g.horeca)}</td><td class="r">${fmt(g.horeca_kg)}</td><td class="r">${fmt(g.fason)}</td><td class="r">${fmt(g.fason_kg)}</td><td class="r b">${fmt(g.toplam)}</td><td class="r">${fmt(g.toplam_kg)}</td></tr>`;
    });
    b += `<tr class="tot"><td>GENEL TOPLAM</td><td class="r">${fmt(genel.horeca)}</td><td class="r">${fmt(genel.horeca_kg)}</td><td class="r">${fmt(genel.fason)}</td><td class="r">${fmt(genel.fason_kg)}</td><td class="r">${fmt(genel.toplam)}</td><td class="r">${fmt(genel.toplam_kg)}</td></tr>`;
    w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>Siparişler İş Bölümü Özeti - ${damga()}</title>
      <style>@page{size:A4 portrait;margin:14mm}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}body{font-family:'Segoe UI',Arial,sans-serif;color:#18181B;margin:0}
      .hdr{display:flex;align-items:center;justify-content:space-between;border-bottom:3px solid #2563eb;padding-bottom:12px;margin-bottom:14px}
      .hdr .l{display:flex;align-items:center;gap:14px}.hdr img{height:52px}.hdr h1{font-size:20px;margin:0}.hdr .sub{font-size:12px;color:#6b7280;margin-top:2px}
      .hdr .meta{text-align:right;font-size:11px;color:#6b7280;line-height:1.6}
      table{width:100%;border-collapse:collapse;font-size:12px}th{background:#18181B;color:#fff;padding:8px;text-align:left;font-size:10px;text-transform:uppercase}
      td{border-bottom:1px solid #eee;padding:6px 10px}.r{text-align:right}.b{font-weight:800}
      tr.tot td{background:#DBEAFE;color:#1e3a8a;font-weight:800;border-top:2px solid #2563eb}
      .foot{margin-top:16px;font-size:10px;color:#9ca3af;text-align:center;border-top:1px solid #eee;padding-top:8px}</style></head>
      <body><div class="hdr"><div class="l"><img src="${window.location.origin}/by-bone-logo.png"/><div><h1>Siparişler — İş Bölümü Özeti</h1><div class="sub">BY BONE PORSELEN — İçerde Bekleyen Siparişlerin İş Bölümü Dağılımı</div></div></div>
      <div class="meta">Tarih: ${new Date().toLocaleString("tr-TR")}<br/>Genel Toplam: ${fmt(genel.toplam)} adet · ${fmt(genel.toplam_kg)} kg</div></div>
      <table><thead><tr><th>İş Bölümü</th><th class="r">Horeca</th><th class="r">Horeca KG</th><th class="r">Fason</th><th class="r">Fason KG</th><th class="r">Toplam</th><th class="r">Toplam KG</th></tr></thead><tbody>${b}</tbody></table>
      <div class="foot">Bu rapor BY BONE Üretim Takip Sistemi tarafından otomatik oluşturulmuştur.</div></body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 400);
  };

  return (
    <div className="rounded-lg bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800 p-6 shadow-xl" data-testid="siparis-is-bolumu-raporu">
      <div className="flex items-center gap-2 mb-4 flex-wrap">
        <Layers className="text-sky-400" size={18} />
        <h3 className="font-head font-black uppercase tracking-[0.2em] text-white text-sm">Siparişler — İş Bölümü Özeti</h3>
        <div className="ml-auto flex items-center gap-2 no-print">
          <div className="inline-flex rounded-md bg-white/5 border border-white/10 p-0.5" data-testid="isbolum-sort-toggle">
            <button onClick={() => setSortBy("adet")} data-testid="isbolum-sort-adet"
              className={`flex items-center gap-1 px-2 py-1 rounded text-[11px] font-semibold transition-colors ${sortBy === "adet" ? "bg-sky-500 text-zinc-900" : "text-zinc-300 hover:text-white"}`}>
              <ArrowDownWideNarrow size={12} /> Adet
            </button>
            <button onClick={() => setSortBy("isim")} data-testid="isbolum-sort-isim"
              className={`flex items-center gap-1 px-2 py-1 rounded text-[11px] font-semibold transition-colors ${sortBy === "isim" ? "bg-sky-500 text-zinc-900" : "text-zinc-300 hover:text-white"}`}>
              <ArrowDownAZ size={12} /> İsim
            </button>
          </div>
          <button onClick={exportExcel} data-testid="isbolum-excel-btn"
            className="flex items-center gap-1.5 bg-emerald-500/15 border border-emerald-400/30 text-emerald-300 hover:bg-emerald-500/25 text-xs font-semibold px-2.5 py-1.5 rounded transition-colors">
            <FileDown size={13} /> Excel
          </button>
          <button onClick={exportPdf} data-testid="isbolum-pdf-btn"
            className="flex items-center gap-1.5 bg-red-500/15 border border-red-400/30 text-red-300 hover:bg-red-500/25 text-xs font-semibold px-2.5 py-1.5 rounded transition-colors">
            <Printer size={13} /> PDF
          </button>
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="py-10 text-center text-zinc-500 text-sm">İçerde bekleyen sipariş yok.</div>
      ) : (
        <div className="overflow-x-auto rounded-md border border-white/10" data-testid="isbolum-tablo">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-white/5 text-[10px] uppercase tracking-wider text-zinc-400">
                <th className="text-left px-4 py-2.5 font-semibold">İş Bölümü</th>
                <th className="text-right px-4 py-2.5 font-semibold">Horeca</th>
                <th className="text-right px-4 py-2.5 font-semibold">Fason</th>
                <th className="text-right px-4 py-2.5 font-semibold">Toplam</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {sortRows(rows).map((g) => (
                <React.Fragment key={g.is_bolumu}>
                  <tr onClick={() => toggle(g.is_bolumu)} className="hover:bg-white/5 transition-colors cursor-pointer" data-testid={`isbolum-satir-${g.is_bolumu}`}>
                    <td className="px-4 py-2.5">
                      <span className="flex items-center gap-2 text-zinc-200 font-medium">
                        {open[g.is_bolumu] ? <ChevronDown size={14} className="text-sky-400" /> : <ChevronRight size={14} className="text-zinc-500" />}
                        <Layers size={12} className="text-sky-500/70" /> {g.is_bolumu}
                      </span>
                    </td>
                    <td className="px-4 py-2.5 text-right">
                      <span className="num font-semibold text-amber-300">{fmt(g.horeca)}</span>
                      <span className="block text-[10px] num text-zinc-500">{fmt(g.horeca_kg)} kg</span>
                    </td>
                    <td className="px-4 py-2.5 text-right">
                      <span className="num font-semibold text-violet-300">{fmt(g.fason)}</span>
                      <span className="block text-[10px] num text-zinc-500">{fmt(g.fason_kg)} kg</span>
                    </td>
                    <td className="px-4 py-2.5 text-right">
                      <span className="num font-black text-sky-300">{fmt(g.toplam)}</span>
                      <span className="block text-[10px] num text-emerald-300/80">{fmt(g.toplam_kg)} kg</span>
                    </td>
                  </tr>
                  {open[g.is_bolumu] && (
                    <tr data-testid={`isbolum-detay-${g.is_bolumu}`}>
                      <td colSpan={4} className="px-3 pb-3 pt-0 bg-black/20">
                        <SiparisDetay list={g.siparisler} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-sky-500/10 border-t-2 border-sky-400/30" data-testid="isbolum-genel-toplam">
                <td className="px-4 py-2.5 font-head font-black uppercase tracking-wide text-sky-300 text-xs">Genel Toplam</td>
                <td className="px-4 py-2.5 text-right">
                  <span className="num font-black text-amber-300">{fmt(genel.horeca)}</span>
                  <span className="block text-[10px] num text-zinc-400">{fmt(genel.horeca_kg)} kg</span>
                </td>
                <td className="px-4 py-2.5 text-right">
                  <span className="num font-black text-violet-300">{fmt(genel.fason)}</span>
                  <span className="block text-[10px] num text-zinc-400">{fmt(genel.fason_kg)} kg</span>
                </td>
                <td className="px-4 py-2.5 text-right">
                  <span className="num font-black text-sky-200">{fmt(genel.toplam)}</span>
                  <span className="block text-[10px] num text-emerald-300">{fmt(genel.toplam_kg)} kg</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}
